












import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action} from 'vuex-class';

@Component
export default class PostCommentField extends Vue {
  @Prop({type: Object, default: {}}) private post!: any;
  @Prop({type: Function, default: () => ({})}) private callback!: any;

  private commentText: string = '';
  private loading: boolean = false;

  @Action('user/likes/create') private createLike!: (post: any) => Promise<boolean>;
  @Action('user/likes/del') private removeLike!: (post: any) => Promise<boolean>;
  @Action('user/posts/readOne') private readPost!: ({ id }) => Promise<boolean>;

  private async like() {
    this.loading = true;
    if (!this.post.liked) {
      await this.createLike(this.post);
    } else {
      await this.removeLike(this.post);
    }
    await this.readPost(this.post);
    this.$emit('update', this.post);
    this.callback();
    this.loading = false;
  }

}
